import Vue from "vue"
import Router from "vue-router"
import { publicRoute, protectedRoute } from "./config"
import NProgress from "nprogress"
import "nprogress/nprogress.css"
const routes = publicRoute.concat(protectedRoute)
import store  from '../store'

Vue.use(Router)
const router = new Router({
  mode: "history",
  linkActiveClass: "active",
  routes: routes
})

// Router Guards

router.beforeEach((to, from, next) => {

    store.commit("SetLoading",true)
    // NProgress.start()
    const PublicPages  = ['Login'];
    const AuthRequired = !PublicPages.includes(to.name);
    let loggedIn       = GetCookie('access_token')
    if (AuthRequired && !loggedIn) {

        return next('/login');

    }else if(!AuthRequired && loggedIn){

        return next('/')
    }
    next();

})


function GetCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
          c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
      }
  }
  return "";
}

export default router
